import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** The label: the box and its words on one line, the words wrapping beside the box. */
export const CHECKBOX_LABEL_STYLE = {
    display: "inline-flex",
    alignItems: "flex-start",
    gap: "var(--space-2)",
    font: "500 var(--h6-size)/1.4 var(--font-ui)",
    color: "var(--ard-text)",
};
/** The box: the accent when ticked, the kit's control size, never shrunk by long words. */
export const CHECKBOX_BOX_STYLE = {
    accentColor: "var(--ard-coral)",
    width: "16px",
    height: "16px",
    margin: "2px 0 0",
    flexShrink: 0,
};
export function Checkbox({ label, checked, onCheckedChange, className = "", disabled, ...rest }) {
    return (_jsxs("label", { className: `ds-checkbox ${className}`.trim(), style: { ...CHECKBOX_LABEL_STYLE, cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.6 : 1 }, children: [_jsx("input", { type: "checkbox", checked: checked, disabled: disabled, onChange: (event) => onCheckedChange(event.target.checked), style: { ...CHECKBOX_BOX_STYLE, cursor: disabled ? "default" : "pointer" }, ...rest }), _jsx("span", { children: label })] }));
}
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map